import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminDashboard.css';

// Estructura alineada al menú del sitio: Inicio, Directorio, Pastoral, Comunicaciones, Parroquias + Sistema
const SECTIONS = [
  {
    id: 'inicio',
    title: 'Inicio',
    description: 'Contenido del menú Inicio: Historia, Misión, Visión, Obispo, Insignias, Autoridades.',
    cards: [
      { to: '/admin/slider', title: 'Slider Inicio', desc: 'Imágenes del carrusel de la página de inicio', icon: '🖼️' },
      { to: '/admin/secciones-inicio', title: 'Secciones Inicio', desc: 'Editar Historia (completa), Misión, Visión, Obispo, Insignias (texto, imágenes slider y video YouTube)', icon: '📄' },
      { to: '/admin/autoridades', title: 'Autoridades / Clero', desc: 'Gestionar autoridades y descripción de obispos', icon: '👥' },
    ],
  },
  {
    id: 'directorio',
    title: 'Directorio',
    description: 'Curia diocesana, medios de comunicación y servicios. Teléfonos, direcciones y contacto general.',
    cards: [
      { to: '/admin/secciones-directorio', title: 'Secciones Directorio', desc: 'Teléfono, dirección y texto de cada ítem (Curia, Medios, Servicios). Página Servicios.', icon: '📋' },
      { to: '/admin/search-profile', title: 'Perfiles', desc: 'Autoridades, misioneros, párrocos, voluntarios (directorio de personas)', icon: '🔍' },
    ],
  },
  {
    id: 'pastoral',
    title: 'Pastoral',
    description: 'Editar teléfono, dirección, texto e imagen de cada ítem del menú Pastoral.',
    cards: [
      { to: '/admin/secciones-pastoral', title: 'Secciones Pastoral', desc: 'Teléfono, dirección, texto e imagen de cada ítem Pastoral', icon: '📿' },
    ],
  },
  {
    id: 'comunicaciones',
    title: 'Comunicaciones',
    description: 'Alineado con el menú: Comunicados oficiales, Convocatorias, Decretos, Noticias, Políticas, Galería.',
    cards: [
      { to: '/admin/noticias', title: 'Comunicados oficiales / Noticias', desc: 'Gestionar comunicados y noticias', icon: '📰' },
      { to: '/admin/convocatorias', title: 'Convocatorias', desc: 'Gestionar convocatorias y anuncios', icon: '📢' },
      { to: '/admin/gaceta', title: 'Decretos', desc: 'Gestionar gaceta y decretos', icon: '📄' },
      { to: '/admin/politicas', title: 'Políticas institucionales', desc: 'Política de privacidad, Protección a Menores, Tratamiento de datos', icon: '📋' },
      { to: '/admin/galeria', title: 'Galería fotográfica Destellos de Fe', desc: 'Gestionar fotografías y videos', icon: '📸' },
    ],
  },
  {
    id: 'parroquias',
    title: 'Parroquias',
    description: 'Parroquias y horarios de misa.',
    cards: [
      { to: '/admin/parroquias', title: 'Parroquias', desc: 'Gestionar parroquias y horarios de misa', icon: '⛪' },
    ],
  },
  {
    id: 'casas-encuentro',
    title: 'Casas de encuentro',
    description: 'Editar información de Casa Pastoral de San Juan y Casa Sacerdotal El Capulí.',
    cards: [
      { to: '/admin/casas-encuentro', title: 'Casas de encuentro', desc: 'Editar título, descripción, teléfono, dirección e imágenes de Casa Pastoral de San Juan y Casa El Capulí', icon: '🏠' },
    ],
  },
  {
    id: 'donaciones',
    title: 'Donaciones',
    description: 'Gestionar donaciones recibidas y configurar la campaña (imagen, cuenta bancaria, título).',
    cards: [
      { to: '/admin/donaciones', title: 'Donaciones', desc: 'Ver donaciones recibidas, configurar campaña actual, imagen y datos bancarios', icon: '💝' },
    ],
  },
  {
    id: 'configuracion',
    title: 'Configuración general',
    description: 'Datos globales del sitio y administración de usuarios.',
    cards: [
      { to: '/admin/configuracion', title: 'Configuración del sitio', desc: 'Teléfono, dirección, email, texto botón Donar y enlaces principales', icon: '⚙️' },
      { to: '/admin/usuarios', title: 'Usuarios', desc: 'Gestionar usuarios y permisos de acceso al panel', icon: '👤' },
    ],
  },
];

const AdminDashboard = () => {
  const { user, logout } = useAuth();

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <div className="container">
          <h1>Panel de Administración</h1>
          <p className="dashboard-header-sub">Organizado como el menú del sitio para encontrar fácilmente qué editar.</p>
          <div className="dashboard-user">
            <span>Bienvenido, {user?.nombre || user?.email}</span>
            <button onClick={logout} className="btn btn-secondary">
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>

      <div className="dashboard-content">
        <div className="container">
          {SECTIONS.map((section) => (
            <section key={section.id} className="dashboard-section" aria-labelledby={`section-${section.id}`}>
              <h2 id={`section-${section.id}`} className="dashboard-section-title">
                {section.title}
              </h2>
              <p className="dashboard-section-desc">{section.description}</p>
              <div className="dashboard-grid">
                {section.cards.map((card) => (
                  <Link key={card.to} to={card.to} className="dashboard-card">
                    <h3><span className="dashboard-card-icon" aria-hidden="true">{card.icon}</span> {card.title}</h3>
                    <p>{card.desc}</p>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
